import React from 'react';
export function Navigation() {
  return <nav className="bg-white shadow-sm py-3 sticky top-0 z-50" data-id="element-270">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <div className="flex justify-between items-center" data-id="element-272">
          <div className="flex items-center" data-id="element-273">
            <a href="https://tryayacaps.com" className="flex items-center" data-id="element-274">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pKKdeA6gpbpZX6LQHFYivh/Untitled_design_54.png" alt="Aya Caps Logo" className="h-10 w-auto" data-id="element-275" />
              <span className="ml-2 text-xl font-semibold text-green-800" data-id="element-276">
                Aya Caps
              </span>
            </a>
          </div>
          <div className="hidden md:flex items-center space-x-6" data-id="element-277">
            <a href="https://tryayacaps.com" className="text-gray-700 hover:text-green-600 transition-colors" data-id="element-278">
              Try Now
            </a>
            <a href="https://tryayacaps.com" className="text-gray-700 hover:text-green-600 transition-colors" data-id="element-279">
              Studies
            </a>
            <a href="https://tryayacaps.com" className="text-gray-700 hover:text-green-600 transition-colors" data-id="element-280">
              About Us
            </a>
            <a href="https://tryayacaps.com" className="text-gray-700 hover:text-green-600 transition-colors" data-id="element-281">
              Contact
            </a>
          </div>
          <div className="md:hidden" data-id="element-282">
            <button className="text-gray-700 hover:text-green-600 focus:outline-none" data-id="element-283">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-284">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-285" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>;
}